import MuiDialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';

import CloseIcon from '@/assets/icons/CloseIcon';
import styles from './Dialog.styles';
import { PROPS } from './Dialog.utils';

export default function Dialog({
  title,
  body,
  footer,
  onClose,
  p,
  padding,
  bgColor,
  backgroundColor,
  background,
  width,
  bodySx,
  ...rest
}: PROPS) {
  const blockStyles = {
    p: p || padding || '0 24px',
    backgroundColor: bgColor || backgroundColor || background,
  };

  return (
    <MuiDialog
      {...rest}
      PaperProps={{
        sx: {
          maxWidth: 'unset',
          ...(width ? { width: `${width}px` } : {}),
        },
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        minHeight="52px"
        sx={blockStyles}
      >
        <DialogTitle sx={styles.title}>{title}</DialogTitle>
        <IconButton aria-label="close" onClick={onClose} sx={styles.close}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <DialogContent sx={{ ...blockStyles, ...bodySx }}>{body}</DialogContent>
      {footer && <DialogActions sx={blockStyles}>{footer}</DialogActions>}
    </MuiDialog>
  );
}
